import { FormControlLabel, Switch } from '@mui/material'
import { useState } from 'react'
import Highlight from 'react-highlight'

type Props = {
  children: string
  language?: string
}

const CodeFormat = ({ children, language }: Props) => {
  const [showRender, setShowRender] = useState<boolean>(false)

  return (
    <div>
      <FormControlLabel
        sx={{ zIndex: 99 }}
        value={showRender}
        control={
          <Switch
            color="primary"
            onChange={(e) => setShowRender(e.target.checked)}
          />
        }
        label="Formato"
        labelPlacement="end"
      />
      {showRender ? (
        <Highlight className={language || 'html'}>{children}</Highlight>
      ) : (
        <div>{children}</div>
      )}
    </div>
  )
}

export default CodeFormat
